<template>
  <div class="grid-layer">
    <div style="position: relative;">
      <table ref="table" :class="{transparent:!visible}">
        <tr v-for="(row, indexY) in cells" v-bind:key="row[0].key">
          <td
            v-bind:class="{cell: cell.key != currentZone, 'cell-active': cell.key == currentZone}"
            v-for="(cell, indexX) in row"
            v-bind:key="cell.key"
            :style="{width:tileWidth+'px', height:tileHeight+'px'}"
            v-on:click="onClickCell(cell)"
          >
            <area-cell :x="cell.x" :y="cell.y" v-if="isArea(cell)" />
            <div
              v-if="mapType == 0"
              v-bind:style="{'background-image': `url('/img/world/bg_world_m_${parseInt(indexY) * 8 + parseInt(indexX) + 1}.png')`, width: '100%', height: '100%', 'padding-top': '12px', 'background-size': '100% 100%'}"
            >
              <div
                style="font-size: 14px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    text-align: center; color: white; height: 100%;"
              ></div>
              <img
              v-if="!IsAvailableZone(cell)"
                v-bind:src="`/img/bg_world_none_${((cell.x + cell.y) % 2) + 1}.png`"
                style="position: absolute; left:0px; top:0px;"
                v-bind:width="`${tileWidth}px`"
                v-bind:height="`${tileHeight}px`"
              />
              <img
                src="/img/select_world.png"
                v-if="cell.key == currentZone"
                style="position: absolute; left:0px; top:0px; width: 100%; height: 100%;"
              />
            </div>
            <div
              v-if="mapType == 1"
              v-bind:style="{'background-image': cellImg(cell), width: '100%', height: '100%', 'background-size': '100% 100%', position: 'relative'}"
            >
              <img
              src="/img/select_zone.png"
              v-if="parseInt(cell.key) === parseInt(selectedLandId)"
              width="100%"
              style="position: absolute; left: 0px; top: 0px;"
            />
            <img
              src="/img/1st_sale/icon_select.png"
              v-if="IsSelected(cell.key)"
              width="100%"
              style="position: absolute; left: 0px; top: 0px;"
            />
            </div>
            <!-- <div v-if="mapType == 1 && visibleDevRank == 'on'" v-bind:style="{width: '100%', height: '100%', 'background-color': devColor[cell.rank]}"></div>           -->
          </td>
        </tr>
      </table>      
      <!-- <div v-if="mapType == 1" style="width: 35px; height: 35px; position: absolute; left: 8px; top: 7px; pointer-events : none;">
        <img src="/img/object_10.png" width="100%">
      </div> -->
    </div>
    <div
      v-if="mapType == 1 && numScrolling > 0"
      style="position: fixed; left: 0px; top: 260px; width: 130px; height: 130px; border: 1px solid black; background-color: #00000099;"
    >
      <div
        v-bind:style="{width: `${minimapScroll[2]}px`, height: `${minimapScroll[3]}px`, left: `${minimapScroll[0]}px`, top: `${minimapScroll[1]}px`, position: 'absolute', border: '1px solid #fff568'}"
      ></div>
    </div>
    <div
      v-if="selected.modal"
      style="position: fixed; left: 0px; top: 0px; width: 100vw; height: 100vh; background-color: #00000099; z-index: 100000;"
    >
      <div class="gamemap-scroll-area" v-bind:style="{position: 'absolute', top: 'calc((100% - 580px) / 2)', left:'calc((100% - 320px)/2)', 'width': '320px', 'height': '320px'}">
        <div v-for="object in trees" v-bind:key="object._id">
          <div
            v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'40px', height:'40px'}"
          >
            <img v-bind:src="`/img/Tiles/fo_${object.code}.png`" width="100%" />
          </div>
        </div>
        <div v-for="object in objects" v-bind:key="object._id">
          <div
            v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'40px', height:'40px'}"
          >
            <img
              v-if="object.display != null"
              v-bind:src="`/img/object_${object.display}.png`"
              width="100%"
            />
            <h5
              v-if="object.display != null"
              style="width:100%; height: 100%; text-align: center; margin-top: -13px; color: white; font-size: 0.7em;"
            >Lv.{{object.level}}</h5>
          </div>
        </div>
      </div>
      <div
        class="land-info-area2"
        v-if="landInfo != null"
        v-bind:style="{top: 'calc((100% - 580px) / 2 + 320px)', left:'calc((100% - 320px)/2)', 'position': 'absolute', 'width': '320px', 'height': '165px'}"
      >
        <table style="width: 100%; margin-top: -5px;">
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('head_landId')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">Land #{{landInfo.landId}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Dev. Rank')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.devRank}}</h6>
            </td>
          </tr>
          <tr style="height: 56px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Owner')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3" v-if="landInfo.owner != null">
                <a
                  v-bind:href="getEtherScanUrl(landInfo.owner.address)"
                  target="_blank"
                >{{landInfo.owner.address}}</a>
              </h6>
              <h6 class="card-title3" v-if="landInfo.owner == null">{{$t('not_own')}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('devpoints')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.devPoint}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Reward Cumulative')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.stats.token}} DAI</h6>
            </td>
          </tr>
          <!-- <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('sale_status')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{$t(`sale_${landInfo.sale.status}`)}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Price')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.sale.price}} ETH</h6>
            </td>
          </tr> -->
        </table>
      </div>
      <div
        v-bind:style="{width: '100%', position: 'absolute', left: '0px', top: 'calc((100% - 580px) / 2 + 480px)', height: '40px', 'text-align': 'center'}"
      >
        <n-button
          type="danger"
          style="width: 140px; margin: 10px;"
          @click.native="selected.modal = false"
        >{{$t('Close')}}</n-button>
        <n-button @click="addToCart(landInfo)" type="info" style="width: 140px; margin: 10px;" v-if="onSale == true && landInfo != null && landInfo.sale.status == 2 && landInfo.sale.reserved == null">{{$t('add to cart')}}</n-button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import config from "../../config.js";
import { Button } from "@/components";
import VueScreenSize from "vue-screen-size";
import ga from "../../ga";

import AreaCell from "./AreaCell.vue";
const CELL_WIDTH = 25;
const CELL_HEIGHT = 25;
export default {
  name: "GridLayer",
  components: { AreaCell, [Button.name]: Button },
  mixins: [VueScreenSize.VueScreenSizeMixin],
  props: {
    viewport: {
      type: Object
    },
    visible: {
      type: Boolean
    },
    visibleDevRank: {
      type: String
    },
    columnCount: { type: Number, default: 32 },
    rowCount: { type: Number, default: 32 },
    tileWidth: { type: Number, default: 25 },
    tileHeight: { type: Number, default: 25 },
    mapType: { type: Number, default: 0 },
    onSale: {
      type: Boolean,
      default: false
    },
    minimapScroll: {
      type: Array
    }
  },
  data: () => ({
    cells: [],
    lands: [],
    devColor: [
      "#d9e99f",
      "#9ca96c",
      "#6ba762",
      "#409050",
      "#207f43",
      "#0d672e",
      "#035229",
      "#014321",
      "#002713",
      "#011200"
    ],
    saleColor: ["#000000", "#999999", "#ffffff"],
    selectedLandId: 0,
    selected: {
      modal: false,
      landId: 0
    },
    objects: [],
    trees: [],
    landInfo: null,
    screenWidth: 320,
    screenHeight: 0,
    numScrolling: 0,
    zones: []
  }),
  computed: {
    allLands() {
      return this.lands;
    },
    allCells() {
      return this.cells;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    currentLandId() {
      if (this.$store.state.area.selectedLand == null) {
        return 0;
      }
      console.log("currentLandId: ", this.$store.state.area.selectedLand[0]);
      return this.$store.state.area.selectedLand[0];
    },
    tableWidth() {
      return CELL_WIDTH * this.columnCount;
    },
    tableHeight() {
      return CELL_HEIGHT * this.rowCount;
    }
  },
  mounted() {
    this.screenWidth = this.$vssWidth;
    this.screenHeight = this.$vssHeight;
    this.$nextTick(async () => {
      console.log("columnCount - ", this.columnCount);

      this.setPositionByViewport();
      let lands = await this.getZoneLands(this.currentZone);
      this.lands = lands;
      this.createCells();
      this.selectedLandId = this.$store.state.area.selectedLandId;
      this.updateCellXY(lands);
      if (this.mapType == 0) {
        this.zones = await this.getZoneStatus();
      }
      setTimeout(() => {
        $(this.$el).css({ opacity: 1 });
      }, 10);
    });
  },
  watch: {
    minimapScroll() {
      ++this.numScrolling;
      setTimeout(() => {--this.numScrolling;}, 1000);
    },
    async currentZone(val, oldVal) {
      if (this.mapType == 0) {
        return;
      } else {
        let lands = await this.getZoneLands(val);
        this.lands = lands;
        this.selectedLandId = this.$store.state.area.selectedLandId;
        this.updateCellXY(lands);
        //this.updateCellXY(val);
      }
    }
  },
  methods: {
    IsAvailableZone: function(cell) {
      if (!this.onSale) {
        return true;
      }
      let zoneId = cell.key;
      for (let i = 0; i < this.zones.length; ++i) {
        if (this.zones[i].zoneId == zoneId) {
          if (this.zones[i].remain <= 0) {
            return false;
          }
          return true;
        }
      }
      return false;
    },
    addToCart: async function(landInfo) {
      let land = {
        landId: landInfo.landId,
        level: landInfo.attributes.devRank,
        price: landInfo.sale.price,
        status: landInfo.sale.status
      };
      // if (!this.$store.state.account.presaleStarted) {
      //   return alert(this.$t('not_start_yet_presale'));
      // }
      this.$store.commit('selectLand', land);
      this.selected.modal = false;

      ga.gaEvent('event', 'addToCart', {
            'event_label': landInfo.attributes.devRank + ''
      });
    },
    getEtherScanUrl: function(address) {
      return `${config.etherscan.account}/${address}`;
    },
    changeLandId: async function(landId) {
      const treeCodes = [501, 502, 503, 504, 505, 601, 602, 603];
      this.trees = [];
      for (let i = 0; i < 10; ++i) {
        this.trees.push({
          _id: i,
          code: treeCodes[Math.floor(Math.random() * treeCodes.length)],
          x: Math.floor(Math.random() * 8) * 40,
          y: Math.floor(Math.random() * 8) * 40
        });
      }
      this.landUrl = `${config.web.url}/map/${landId}`;
      this.landInfo = await this.getLandInfo(landId);
      this.objects = await this.getFieldObjects(landId);
    },
    getLandInfo: function(landId) {
      console.log("getLandInfo - ", landId);
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/land/info?landId=${landId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.land);
            } else {
              reject();
            }
          });
      });
    },
    getFieldObjects: function(landId) {
      console.log("getFieldObjects - ", landId);
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/field/fieldobjects?landId=${landId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              let objects = ret.data.objects;
              landId = landId % 100000;
              let landX = landId % 256;
              let landY = Math.floor(landId / 256);
              let x = landX * 8;
              let y = landY * 8;
              for (let i = 0; i < objects.length; ++i) {
                objects[i].x = (objects[i].loc[1] - x) * 40 - 10;
                objects[i].y = (7 - (objects[i].loc[2] - y)) * 40;
                if (
                  objects[i].code >= 20100101 &&
                  objects[i].code <= 20100104
                ) {
                  objects[i].display = objects[i].code - 20100100;
                } else if (
                  objects[i].code >= 20200101 &&
                  objects[i].code <= 20200103
                ) {
                  objects[i].display = objects[i].code - 20200100 + 4;
                } else if (objects[i].code == 20200201) {
                  objects[i].display = 8;
                }
              }
              resolve(objects);
            } else {
              reject();
            }
          });
      });
    },
    IsSelected: function(landId) {
      for (let i = 0; i < this.$store.state.map.selectedLands.length; ++i) {
        if (this.$store.state.map.selectedLands[i].landId == landId) {
          return true;
        }
      }
      return false;
    },
    cellImg: function(cell) {
      if (cell.owner != false) {
        if (cell.address != null && this.$store.state.account.wallet != null && this.$store.state.account.wallet.address != null && cell.address.toLowerCase() == this.$store.state.account.wallet.address.toLowerCase()) {
          return `url('/img/bg_user.png')`;
        }
        else {
          return `url('/img/1st_sale/bg_buy.png')`;
        }        
      } else {
        if ((cell.sale != 2 || cell.reserved != null) && this.onSale == true) {
          if (cell.x % 2 == cell.y % 2) {
            return `url('/img/bg_none_1.png')`;
          } else {
            return `url('/img/bg_none_2.png')`;
          }
        } else {
          return `url('/img/bg_land_${cell.rank}.png')`;
        }
      }
    },
    cellBgColor: function(cell) {
      switch (cell.rank) {
        case 1:
          return "#e8fff5";
        case 2:
          return "#bdffe3";
        case 3:
          return "#79ffc6";
        case 4:
          return "#54c695";
        case 5:
          return "#3eb7a0";
        case 6:
          return "#299498";
        case 7:
          return "#13718f";
        case 8:
          return "#044979";
        case 9:
          return "#0a2d74";
        case 10:
          return "#05155c";
      }
      return "#e8fff5";
    },
    getHexColor: function(number) {
      return "#" + (number >>> 0).toString(16).slice(-6);
    },
    getZoneStatus: function() {
      return new Promise((resolve, reject) => {
        axios
          .post(`${config.api.nft_url}/presale/allzone`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.zones);
            } else {
              reject();
            }
          });
      });
    },
    getZoneLands: function(zoneId) {
      console.log("getZoneLands - ", zoneId);
      return new Promise((resolve, reject) => {
        //let ret = await axios.post('https://api-stats.leagueofkingdoms.com/api/admin/dashboard', {});
        axios
          .get(`${config.api.game_url}/land/zone/lands?zoneId=${zoneId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.lands);
            } else {
              reject();
            }
          });
      });
    },
    setPositionByViewport() {
      $(this.$el).css({
        left: this.viewport.left,
        top: this.viewport.top
      });
    },
    updateCellXY(lands) {
      let currentZone = this.currentZone;
      const cells = this.cells;
      let idx = 0;
      let currentZoneIdx = 0;
      let startLandId = 100000;
      for (let i = 0; i < this.$store.state.map.zoneMap.length; ++i) {
        if (this.$store.state.map.zoneMap[i] == currentZone) {
          currentZoneIdx = i;
          break;
        }
      }
      let zoneX = currentZoneIdx % 8;
      let zoneY = 7 - Math.floor(currentZoneIdx / 8);
      startLandId = (zoneY * 256 + zoneX) * 32 + 100000;

      console.log("selectedLandId - ", this.selectedLandId);

      for (let i = 0; i < this.rowCount; i++) {
        for (let j = 0; j < this.columnCount; j++) {
          if (this.mapType == 0) {
            let key = this.$store.state.map.zoneMap[idx];
            cells[i][j] = { x: j, y: i, i, j, key, display: key };
          } else {
            let key = startLandId + j + (31 - i) * 256;

            if (lands.length > idx) {
              this.$set(cells[i], j, {
                x: j,
                y: i,
                i,
                j,
                key,
                rank: lands[idx][1],
                display: lands[idx][1],
                sale: lands[idx][3],
                owner: lands[idx][2],
                color: this.getHexColor(lands[idx][4]),
                land: lands[idx],
                reserved: lands[idx][5],
                address: lands[idx][6]
              });
            } else {
              this.$set(cells[i], j, {
                x: j,
                y: i,
                i,
                j,
                key,
                rank: 1,
                display: 0,
                sale: 0,
                owner: false,
                color: "#000000",
                address: null
              });
            }

            if (key == this.selectedLandId) {
              this.onClickCell(cells[i][j]);
            }
          }
          ++idx;
        }
      }

      console.log("updateCell - ", cells);
    },
    // 전체 셀 목록 생성
    createCells() {
      const cells = [];
      console.log("row/column - ", this.rowCount, this.columnCount);
      for (let i = 0; i < this.rowCount; i++) {
        for (let j = 0; j < this.columnCount; j++) {
          if (!cells[i]) {
            cells[i] = {};
          }
        }
      }
      this.cells = cells;
    },
    onClickCell(cell) {
      if (this.mapType == 0) {
        this.selectedLandId = 0;
        this.$store.commit("clickWorldMap", {
          key: cell.key
        });
      } else {
        this.selectedLandId = cell.key;
        this.selected = {
          modal: true,
          landId: this.selectedLandId
        };
        this.changeLandId(this.selectedLandId);
        this.$store.commit("clickMap", {
          key: cell.key,
          land: cell.land
        });
      }
    },
    isArea(cell, areas) {
      areas = areas || this.$store.state.area.areas;
      if (areas == null) {
        return false;
      }
      return areas.find(area => area.x === cell.x && area.y === cell.y);
    }
  }
};
</script>

<style scoped>
.grid-layer {
  user-select: none;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.5s;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
}
.cell {
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.4);
  color: #fff;
  text-align: center;
  font-size: 1px;
}
.cell:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.cell-active {
  position: relative;
  color: #fff;
  text-align: center;
  font-size: 1px;
  box-shadow: 0 0 0 2px #ffc107 inset;
}

.cell-onsale {
  position: relative;
  color: #fff;
  text-align: center;
  font-size: 1px;
  box-shadow: 0 0 0 1px #ffffff inset;
}

.cell-notonsale {
  position: relative;
  color: #fff;
  text-align: center;
  font-size: 1px;
  box-shadow: 0 0 0 1px #333333 inset;
  background-color: #33333344;
}

table.transparent .cell {
  border-color: transparent;
}

.gamemap-area {
  top: 83px;
  width: 328px;
  height: 349px;
  background-image: url("/img/frame_field.png");
  overflow: none;
}
.gamemap-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.gamemap-scroll-area {
  position: absolute;
  top: 10px;
  width: 320px;
  height: 320px;
  background-image: url("/img/map/map_01.png");
  overflow: none;
  border: 1px solid #fff568;
}
.land-info-title {
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.land-info-area2 {
  position: absolute;
  top: 330px;
  height: 218px;
  overflow: none;
  background-image: url("/img/frame_field_info_m.png");
  padding: 10px;
}

td {
  padding: 0px;
}
</style>